<p-toast life="3000" position="bottom-center">
  <ng-template #headless let-closeFn="closeFn" let-message>
    <div [ngClass]="getBackgroundClass(message.severity)" class="rounded-md p-4">
      <div class="flex">
        <div [ngClass]="getIconClass(message.severity)" class="shrink-0 size-5">
          <ng-icon [svg]="getIcon(message.severity)"/>
        </div>
        <div class="ml-3">
          @if (message.summary) {
            <h3 [ngClass]="getTextSummaryClass(message.severity)"
            class="text-sm font-medium">{{ message.summary }}</h3>
          }
          @if (message.detail) {
            <div [ngClass]="getTextDetailClass(message.severity)" class="mt-2 text-sm">
              <p>{{ message.detail }}</p>
            </div>
          }
        </div>
        <div class="ml-auto pl-3">
          <div class="-mx-1.5 -my-1.5">
            <button
              (click)="closeFn($event)"
              [ngClass]="getButtonClass(message.severity)"
              class="inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2" type="button">
              <span class="sr-only">Dismiss</span>
              <svg aria-hidden="true" class="size-5" data-slot="icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>
